export const statsData = [
  { number: '+3500', label: 'عميل راضٍ' },
  { number: '+800', label: 'متجر إلكتروني' },
  { number: '+250', label: 'مطوّر ومصمم' },
  { number: '+50000', label: 'طلب شهري عبر متاجرنا' },
];

export const platformsData = [
  { icon: 'ri-wordpress-line', name: 'ووردبريس', description: 'WooCommerce وتخصيص كامل' },
  { icon: 'ri-store-2-line', name: 'سلة', description: 'متجر سعودي جاهز للإطلاق' },
  { icon: 'ri-code-box-line', name: 'برمجة خاصة', description: 'حلول مخصصة حسب نشاطك' },
];

/** بيانات العرض المرئي — قسم الهيرو */
export const heroVisualData = {
  storeName: 'متجر ندى',
  storeUrl: 'nada-store.sa',
  storeRating: 4.9,
  reviewCount: '2.4K تقييم',
  banner: { text: 'شحن مجاني للطلبات +300 ر.س', icon: 'ri-truck-line' },
  cartCount: 3,
  cartTotal: '1,247 ر.س',
  categories: ['الكل', 'إلكترونيات', 'أزياء'],
  activeCategory: 'إلكترونيات',
  paymentIcons: ['ri-bank-card-line', 'ri-hand-coin-line', 'ri-apple-line'],
  products: [
    {
      name: 'سماعة Air Pro',
      category: 'إلكترونيات',
      price: '349 ر.س',
      oldPrice: '499 ر.س',
      rating: 4.9,
      sold: '+1.2K مبيعة',
      badge: { text: 'الأكثر مبيعًا', tone: 'amber' },
      icon: 'ri-headphone-line',
      accent: 'from-violet-500/35 via-indigo-900/50 to-slate-900',
      featured: true,
    },
    {
      name: 'ساعة ذكية S9',
      category: 'إلكترونيات',
      price: '429 ر.س',
      oldPrice: '599 ر.س',
      rating: 4.8,
      badge: { text: '-28%', tone: 'rose' },
      icon: 'ri-smartphone-line',
      accent: 'from-cyan-500/30 via-teal-950/60 to-slate-900',
    },
    {
      name: 'عطر فاخر 100مل',
      category: 'أزياء',
      price: '289 ر.س',
      rating: 5,
      badge: { text: 'جديد', tone: 'teal' },
      icon: 'ri-drop-line',
      accent: 'from-amber-500/25 via-rose-950/40 to-slate-900',
    },
    {
      name: 'حقيبة جلد طبيعي',
      category: 'أزياء',
      price: '219 ر.س',
      oldPrice: '279 ر.س',
      rating: 4.7,
      icon: 'ri-shopping-bag-3-line',
      accent: 'from-orange-500/20 via-amber-950/30 to-slate-900',
    },
    {
      name: 'شاحن لاسلكي 3في1',
      category: 'إلكترونيات',
      price: '149 ر.س',
      rating: 4.9,
      badge: { text: 'عرض', tone: 'teal' },
      icon: 'ri-battery-charge-line',
      accent: 'from-teal-500/30 via-emerald-950/40 to-slate-900',
    },
    {
      name: 'ماوس ألعاب RGB',
      category: 'إلكترونيات',
      price: '199 ر.س',
      rating: 4.6,
      icon: 'ri-mouse-line',
      accent: 'from-blue-500/25 via-slate-900 to-indigo-950/50',
    },
  ],
  cta: { primary: 'إتمام الشراء', secondary: 'تابي · تمارا · مدى' },
  platforms: [
    { icon: 'ri-wordpress-line', name: 'ووردبريس' },
    { icon: 'ri-store-2-line', name: 'سلة' },
    { icon: 'ri-code-s-slash-line', name: 'برمجة خاصة' },
  ],
  storesBadge: { value: '+800', label: 'متجر إلكتروني' },
};

export type HeroProduct = (typeof heroVisualData.products)[number];

/** بيانات العرض المرئي — قسم لماذا تحتاج متجرًا */
export const problemSolutionVisualData = {
  storeName: 'متجرك',
  storeUrl: 'my-store.sa',
  cartCount: 3,
  cartTotal: '1,247 ر.س',
  products: [
    { name: 'سماعة لاسلكية', price: '249 ر.س', badge: 'الأكثر مبيعًا' },
    { name: 'ساعة ذكية', price: '399 ر.س' },
    { name: 'حقيبة جلد', price: '189 ر.س' },
    { name: 'شاحن سريع', price: '79 ر.س' },
  ],
  orderPreview: {
    id: '#1847',
    status: 'قيد الشحن',
    customer: 'أحمد م.',
    total: '648 ر.س',
  },
  integrations: [
    { icon: 'ri-bank-card-line', label: 'مدى' },
    { icon: 'ri-hand-coin-line', label: 'تابي' },
    { icon: 'ri-calendar-check-line', label: 'تمارا' },
    { icon: 'ri-truck-line', label: 'سمسا · أرامكس' },
    { icon: 'ri-wordpress-line', label: 'ووردبريس' },
    { icon: 'ri-store-2-line', label: 'سلة' },
  ],
  metrics: [
    { icon: 'ri-shopping-cart-2-line', label: 'طلبات اليوم', value: '+128' },
    { icon: 'ri-line-chart-line', label: 'معدل التحويل', value: '3.8%' },
  ],
};

export const featuresData = [
  {
    icon: 'ri-store-3-line',
    title: 'تصميم واجهة متجر احترافية',
    description: 'واجهات عصرية تعكس هوية علامتك وتزيد معدل التحويل والمبيعات',
  },
  {
    icon: 'ri-bank-card-line',
    title: 'ربط بوابات الدفع',
    description: 'مدى، Apple Pay، تابي، تمارا، والدفع عند الاستلام حسب احتياجك',
  },
  {
    icon: 'ri-truck-line',
    title: 'شحن وتوصيل متكامل',
    description: 'ربط شركات الشحن المحلية وتتبع الطلبات داخل المتجر',
  },
  {
    icon: 'ri-search-line',
    title: 'تهيئة SEO للمتجر',
    description: 'بنية ومحتوى مهيأ لمحركات البحث لزيادة الزيارات العضوية',
  },
  {
    icon: 'ri-dashboard-3-line',
    title: 'لوحة تحكم سهلة',
    description: 'إدارة المنتجات، الطلبات، والعملاء بدون خبرة تقنية',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'متجاوب مع الجوال',
    description: 'تجربة شراء سلسة على الهاتف حيث يأتي أغلب عملائك',
  },
  {
    icon: 'ri-coupon-3-line',
    title: 'عروض وكوبونات',
    description: 'خصومات، أكواد ترويجية، وعروض موسمية لزيادة المبيعات',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'دعم بعد الإطلاق',
    description: 'صيانة، تحديثات، ومساعدة فنية بعد تشغيل المتجر',
  },
];

export const workStepsData = [
  {
    step: '01',
    title: 'تحليل النشاط والمنتجات',
    description: 'نفهم منتجاتك، جمهورك، وقنوات البيع لنختار المنصة الأنسب: ووردبريس، سلة، أو برمجة خاصة.',
  },
  {
    step: '02',
    title: 'تصميم تجربة الشراء',
    description: 'نصمم صفحات المنتجات، السلة، والدفع لرحلة شراء واضحة تقلل التخلي عن السلة.',
  },
  {
    step: '03',
    title: 'البرمجة والتكاملات',
    description: 'نبني المتجر ونربط الدفع، الشحن، المخزون، وواتساب حسب متطلباتك.',
  },
  {
    step: '04',
    title: 'الاختبار والأداء',
    description: 'اختبار الطلبات، السرعة، والأمان على مختلف الأجهزة قبل الإطلاق.',
  },
  {
    step: '05',
    title: 'الإطلاق والتدريب',
    description: 'نطلق متجرك وندربك على الإدارة مع دعم فني مستمر.',
  },
];

export const servicesData = [
  {
    icon: 'ri-wordpress-line',
    title: 'متاجر ووردبريس WooCommerce',
    description: 'متجر مرن مع آلاف الإضافات وتحكم كامل في التصميم والمحتوى',
  },
  {
    icon: 'ri-store-2-line',
    title: 'متاجر على منصة سلة',
    description: 'إطلاق سريع بمنصة سعودية مع دفع وشحن محلي جاهز',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'برمجة متجر مخصص',
    description: 'حلول برمجية خاصة عندما تحتاج ميزات فريدة أو تكاملات معقدة',
  },
  {
    icon: 'ri-palette-line',
    title: 'إعادة تصميم متجر قائم',
    description: 'تحديث الواجهة وتحسين تجربة الشراء لمتجرك الحالي',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'ربط إعلانات ومتابعة التحويل',
    description: 'Google Ads، Meta Pixel، وتحليلات لقياس المبيعات بدقة',
  },
  {
    icon: 'ri-tools-line',
    title: 'صيانة وتطوير المتاجر',
    description: 'تحديثات أمنية، إضافة ميزات، ودعم فني دوري',
  },
];

/** صور متاجر إلكترونية من معرض أعمال أوامر الشبكة — aait.sa (مواقع وليس تطبيقات) */
const AAIT_STORES = 'https://aait.sa/wp-content/uploads/2025/02';

export const portfolioData = [
  {
    title: 'متجر الرمال',
    category: 'متجر إلكتروني',
    description: 'متجر منتجات أونلاين — alremalstore.com',
    image: `${AAIT_STORES}/alremal.png`,
    imageBg: 'from-amber-500/25 via-amber-950/30 to-slate-900',
  },
  {
    title: 'عريب',
    category: 'ووردبريس',
    description: 'متجر إلكتروني — areen-aleeth.com',
    image: `${AAIT_STORES}/areen.png`,
    imageBg: 'from-violet-500/20 via-indigo-950/40 to-slate-900',
  },
  {
    title: 'سوق الأنعام',
    category: 'سلة',
    description: 'متجر إلكتروني — souqalanam.com',
    image: `${AAIT_STORES}/434x0ssw.webp`,
    imageBg: 'from-teal-500/25 via-teal-950/35 to-slate-900',
  },
  {
    title: 'متجر ويب',
    category: 'برمجة خاصة',
    description: 'واجهة متجر على سطح المكتب — تصميم وبرمجة مخصصة',
    image: `${AAIT_STORES}/Screenshot_30-3-2024_111443_-1.jpeg`,
    imageBg: 'from-blue-500/20 via-slate-900 to-indigo-950/50',
    wideImage: true,
  },
];

/** بيانات العرض المرئي — قسم لماذا أوامر الشبكة */
export const whyAAITVisualData = {
  dashboardTitle: 'لوحة تحكم المتجر',
  period: 'آخر 30 يومًا',
  kpis: [
    { icon: 'ri-money-dollar-circle-line', label: 'المبيعات', value: '84,320 ر.س', trend: '+12%' },
    { icon: 'ri-shopping-bag-3-line', label: 'الطلبات', value: '1,284', trend: '+8%' },
    { icon: 'ri-user-line', label: 'زوار المتجر', value: '24.5K', trend: '+15%' },
  ],
  recentOrders: [
    { id: '#2091', customer: 'نورة س.', amount: '520 ر.س', status: 'مكتمل' },
    { id: '#2090', customer: 'خالد ع.', amount: '189 ر.س', status: 'جديد' },
    { id: '#2089', customer: 'سارة م.', amount: '1,100 ر.س', status: 'قيد الشحن' },
  ],
  salesChart: [35, 52, 48, 70, 65, 82, 78],
  platforms: [
    { icon: 'ri-wordpress-line', name: 'ووردبريس', share: '42%' },
    { icon: 'ri-store-2-line', name: 'سلة', share: '35%' },
    { icon: 'ri-code-s-slash-line', name: 'برمجة خاصة', share: '23%' },
  ],
  storesBadge: { value: '+800', label: 'متجر إلكتروني' },
  experienceBadge: { value: '+20', label: 'عامًا من الخبرة' },
};

export const whyAAITData = [
  {
    icon: 'ri-store-3-line',
    title: 'خبرة في المتاجر',
    description: 'مئات المتاجر الإلكترونية في السعودية والخليج على منصات متعددة',
  },
  {
    icon: 'ri-award-line',
    title: 'جودة عالية',
    description: 'تصميم وبرمجة بمعايير احترافية تزيد ثقة العميل ومعدل الشراء',
  },
  {
    icon: 'ri-time-line',
    title: 'التزام بالمواعيد',
    description: 'جدول زمني واضح من التحليل حتى إطلاق المتجر',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'أمان ودفع موثوق',
    description: 'تطبيق أفضل ممارسات الأمان وربط بوابات دفع معتمدة',
  },
  {
    icon: 'ri-message-3-line',
    title: 'دعم مستمر',
    description: 'فريق تقني جاهز للصيانة والتحديثات بعد الإطلاق',
  },
];

export const testimonialsData = [
  {
    name: 'فهد العتيبي',
    role: 'صاحب متجر إلكتروني',
    content:
      'أطلقنا متجرنا على سلة مع تصميم مخصص من أوامر الشبكة. المبيعات زادت والواجهة احترافية جدًا.',
    rating: 5,
  },
  {
    name: 'سارة القحطاني',
    role: 'مديرة متجر أزياء',
    content:
      'متجر ووردبريس مع WooCommerce — الفريق فهم احتياجنا وربط الدفع والشحن بسلاسة. تجربة ممتازة.',
    rating: 5,
  },
  {
    name: 'عبدالله المالكي',
    role: 'مؤسس علامة تجارية',
    content:
      'اخترنا برمجة خاصة لميزات فريدة. التسليم في الموعد والدعم بعد الإطلاق سريع ومتعاون.',
    rating: 5,
  },
];

export const navLinks = [
  { label: 'الرئيسية', href: '#hero' },
  { label: 'المنصات', href: '#platforms' },
  { label: 'المميزات', href: '#features' },
  { label: 'مراحل العمل', href: '#steps' },
  { label: 'أعمالنا', href: '#portfolio' },
  { label: 'الأسئلة الشائعة', href: '#faq' },
  { label: 'تواصل معنا', href: '#cta' },
];

export const faqData = [
  {
    question: 'ما الفرق بين ووردبريس وسلة والبرمجة الخاصة؟',
    answer:
      'ووردبريس مناسب للمرونة والتخصيص الكامل. سلة أسرع للإطلاق في السوق السعودي. البرمجة الخاصة عندما تحتاج ميزات أو تكاملات فريدة لا تتوفر جاهزة.',
  },
  {
    question: 'كم تستغرق مدة إنشاء متجر إلكتروني؟',
    answer:
      'متجر سلة: أسبوع إلى أسبوعين. ووردبريس: 2–4 أسابيع. البرمجة الخاصة: 4–12 أسبوعًا حسب التعقيد.',
  },
  {
    question: 'هل تربطون بوابات الدفع السعودية؟',
    answer:
      'نعم، نربط مدى، Apple Pay، تابي، تمارا، والدفع عند الاستلام حسب المنصة والباقة.',
  },
  {
    question: 'هل يمكنني إدارة المنتجات والطلبات بنفسي؟',
    answer:
      'بالتأكيد، نوفر لوحة تحكم سهلة وندربك على إضافة المنتجات ومتابعة الطلبات بعد الإطلاق.',
  },
];
